import useTranslation from "@/hooks/useTranslation";
import { useEmployeeImpactTotals } from "@/pages/dashboard/hooks/useEmployeeImpact";
import MetricWidget from "../../components/MetricWidget/MetricWidget";
import { ImpactMetric } from "../../utils/types";

export default function EmployeeImpactTopContributors({ metric }: { metric: ImpactMetric }) {
  const { data, isLoading, isFetching } = useEmployeeImpactTotals({ metrics: [metric.key] });
  const translation = useTranslation();

  return (
    <MetricWidget
      title={"Employee footprint"}
      tooltip={translation["dashboard"]["employee"]["total"]}
      loading={isLoading || isFetching}
      format={metric.formatter}
      metric={metric}
      data={{
        value: data?.employee_impact[metric.key],
        comparison: {
          label: "of company total",
          value: data?.company_impact[metric.key],
        },
      }}
    />
  );
}
